<div class="login-main-container">
  <div class="login-side-logo" *ngIf="!isTabView">
    <img
      appPrependUrl
      src="/assets/images/transparent-home-login.png"
      alt="MyGooru Logo"
      class="logo"
    />
  </div>
  <div class="login-content-container">
     <div (click)="goBack()" *ngIf="!isTabView" class="back-button-container">
      <img class="back-button" appPrependUrl src="/assets/icons/arrow-back.svg" alt="arrow-back" />
    </div>
    <div class="login-img-container">
      <div class="illustration-container">
        <img appPrependUrl src="/assets/images/myg-mobile-profile.svg" alt="Learning Illustration" />
      </div>
      <div class="content-wrapper">
        <div class="login-title-container">
          <div class="login-title">Sign in with Username</div>
        </div>
        <div *ngIf="tenantImage; else showAvatar" class="logo-img-wrapper">
          <img class="myg-ai-header-tenant-logo" [src]="tenantImage" alt="Tenant Logo" />
        </div>
        <ng-template #showAvatar>
          <div class="avatar">{{ getInitials(tenantName) }}</div>
        </ng-template>
        <!-- <div class="tenant-name">
          <span> {{tenantName}}</span>
        </div> -->
        <form [formGroup]="signInForm" (ngSubmit)="login()" class="login-form" autocomplete="off">
          <div class="login-form-container">
            <div class="input-wrapper">
              <label class="input-label" for="username">Username</label>
              <input id="username" [(ngModel)]="usernameVal" [formControlName]="'username'" name="username" />
            </div>
            <div class="input-wrapper">
              <label class="input-label" for="password">Password</label>
              <div class="input-visibility">
                <input id="password" [type]="inputType" [formControlName]="'password'" name="password"
                  [attr.clearOnEdit]="false" />

                <span class="password-toggle" (click)="togglePasswordVisibility()">
                  <span class="material-icons">
                    {{
                    inputType === "password" ? "visibility_off" : "visibility"
                    }}
                  </span>
                </span>
              </div>
            </div>
            <div *ngIf="submitted && errorMessage" class="danger-text">
              {{ errorMessage }}
            </div>
          </div>
          <span class="forgotPassword-label" (click)="forgotPassword()">Forgot password?</span>
          <button class="submit-btn" type="submit">SUBMIT</button>
        </form>
      </div>
    </div>
  </div>
</div>